import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import * as CryptoJS from 'crypto-js';
import { DatePipe } from '@angular/common';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-employmentsummary',
  templateUrl: './employmentsummary.component.html',
  styleUrls: ['./employmentsummary.component.css']
})
export class EmploymentsummaryComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Employer', field: 'employer' },
    {headerName: 'Employment Type', field: 'employmentType' },
    {headerName: 'Employment Start Date', field: 'employmentStartdate'},
    {headerName: 'Employment End Date', field: 'employmentEnddate'}
];

rowData = [];

constructor(public loginService:LoginService, public toastService:ToastrService,
  private datePipe: DatePipe){}

  ngOnInit() {
    this.getUserInfo(this.loginService.personId);
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  getUserInfo(id){
    this.loginService.getuser(id).subscribe((data)=>{
      if(data["id"]){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  
        this.getAriescitizenInfo(data["emciId"]) :this.getcitizenInfo(data["ssn"]);
      }
      else{
        this.toastService.error("Unable to load User Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
  }
  getcitizenInfo(ssn){
    let request = {
      "ssn":ssn
    }
    this.loginService.getClientinfo(request).subscribe((data:Array<Object>)=>{
      if(data[0]["CLIENTID"]){
        data.forEach((element)=>{
          let record = {
            employer:null,
            employmentType:null,
            employmentStartdate:null,
            employmentEnddate:null
          }
          if(element["EMPLOYER"] != null){
            record.employer = element["EMPLOYER"];
          }
          if(element["EMP_TYPE"] != null && this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]) != undefined){
            record.employmentType = this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]).name;
          }
          else{
            record.employmentType = element["EMP_TYPE"];
          }
          if(element["EMP_START"] != null){
            // record.employmentStartdate = element["EMP_START"].toString().split(" ")[0];
            record.employmentStartdate= this.datePipe.transform(element["EMP_START"].toString().split(" ")[0], 'MM/dd/yyyy');
          }
          if(element["EMP_END"] != null){
            record.employmentEnddate = element["EMP_END"].toString().split(" ")[0];
            record.employmentEnddate= this.datePipe.transform(element["EMP_END"].toString().split(" ")[0], 'MM/dd/yyyy');
          }
          if(record.employer != null){
            this.rowData.push(record);
          }
        })
        this.gridApi.setRowData(this.rowData);
      }
      else{
        this.toastService.error("Unable to load Employment Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load Employment Information","My Information");
    })
  }

  getAriescitizenInfo(value){
    let request = {
      "type":"empInfo",
      "value":value
    }
    this.loginService.getClietinfoAries(request).subscribe((data:Array<Object>)=>{
      if(data.length > 0){
        data.forEach((element)=>{
          let record = {
            employer:null,
            employmentType:null,
            employmentStartdate:null,
            employmentEnddate:null
          }
          if(element["employer"] != null){
            record.employer = element["employer"];
          }
          /*if(element["EMP_TYPE"] != null && this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]) != undefined){
            record.employmentType = this.loginService.staticData.get("EmploymentType").find(obj => obj.value == element["EMP_TYPE"]).name;
          }
          else{
            record.employmentType = element["EMP_TYPE"];
          }*/
          if(element["effBeginDt"] != null){
            // record.employmentStartdate = element["EMP_START"].toString().split(" ")[0];
            record.employmentStartdate= this.datePipe.transform(new Date(element["effBeginDt"]), 'MM/dd/yyyy');
          }
          if(element["effEndDate"] != null){
            //record.employmentEnddate = element["EMP_END"].toString().split(" ")[0];
            record.employmentEnddate= this.datePipe.transform(new Date(element["effEndDate"]), 'MM/dd/yyyy');
          }
          if(record.employer != null){
            this.rowData.push(record);
          }
        })
        this.gridApi.setRowData(this.rowData);
      }
      else{
        this.toastService.error("Unable to load Employment Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load Employment Information","My Information");
    })
  }
  focus(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell(0, firstCol);
      }
    }
    else{
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/employmentsummary/employmentsummary.component.ts